import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=31ab1141&scoped=true"
import script from "./LabelValue.vue?vue&type=script&lang=js"
export * from "./LabelValue.vue?vue&type=script&lang=js"
import style0 from "./LabelValue.vue?vue&type=style&index=0&id=31ab1141&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab1141",
  null
  
)

export default component.exports